import { useEffect, useState } from 'react'
import { useTitle } from "../../../hooks/useTitle";
import { useCart } from '../../../context/CartContext'
import CatalogCartProduct from "../../../components/ChatbotCatalog/CatalogCartProduct";
import CartEmpty from '../../../components/Cart/CartEmpty'
import * as S from './styles'
import CatalogBreadcrumb from '../../../components/ChatbotCatalog/CatalogBreadcrumb';
import LoadingBackground from '../../../components/LoadingBackground';

const CatalogCart = () => {
  const { buildCharbotCartInvoiceObj, chatbotCart, chatbotCartObj, clearCart } = useCart()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const initializeCart = async () => {
      if (chatbotCartObj && Object.keys(chatbotCartObj)?.length > 0) {
        await buildCharbotCartInvoiceObj()
      }
      setIsLoading(false)
    }
    initializeCart()
  }, [])

  useTitle('Carrinho de compras')

  if (isLoading) {
    return <LoadingBackground />
  }

  return (
    <S.CatalogCart>
      {chatbotCart && chatbotCart?.items?.length > 0
      ? (
        <>
          <CatalogBreadcrumb parent='Resumo do Meu Pedido' />
          {/* <S.Title>Resumo do Meu Pedido</S.Title> */}
          <S.CartProductsList>
            {chatbotCart && (
              chatbotCart.items.map(product => (
                <CatalogCartProduct key={product.productId} product={product} />
              ))
            )}
          </S.CartProductsList>
          <S.InvoiceInformation>
            <S.InvoiceMiddleInformation>
              <S.InvoiceValuesWrapper>
                <S.CommomInvoiceInformationLabel>Subtotal</S.CommomInvoiceInformationLabel>
                <S.CommomInvoiceInformationValue>
                  {chatbotCart.value.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </S.CommomInvoiceInformationValue>
              </S.InvoiceValuesWrapper>
              <S.InvoiceValuesWrapper>
                <S.CommomInvoiceInformationLabel>Desconto</S.CommomInvoiceInformationLabel>
                <S.CommomInvoiceInformationValue>
                  {chatbotCart.politicsDiscount.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </S.CommomInvoiceInformationValue>
              </S.InvoiceValuesWrapper>
              <S.InvoiceValuesWrapper>
                <S.CommomInvoiceInformationLabel>Impostos</S.CommomInvoiceInformationLabel>
                <S.CommomInvoiceInformationValue>
                  {chatbotCart.tax.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </S.CommomInvoiceInformationValue>
              </S.InvoiceValuesWrapper>
              <S.InvoiceValuesWrapper>
                <S.CommomInvoiceInformationLabel>Frete</S.CommomInvoiceInformationLabel>
                <S.CommomInvoiceInformationValue>
                  {chatbotCart.freight.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </S.CommomInvoiceInformationValue>
              </S.InvoiceValuesWrapper>
              <S.InvoiceValuesWrapper>
                <S.TotalInvoiceInformationLabel>Total Geral</S.TotalInvoiceInformationLabel>
                <S.TotalInvoiceInformationValue>
                  {chatbotCart.totalValue.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </S.TotalInvoiceInformationValue>
              </S.InvoiceValuesWrapper>
            </S.InvoiceMiddleInformation>
          </S.InvoiceInformation>
          <S.ButtonLink to={'/chatbot-catalog/cart/cart-payment'}>
            <S.GoToPaymentButton>Ir para pagamento</S.GoToPaymentButton>
          </S.ButtonLink>
          <S.ClearCartButton onClick={clearCart}>Limpar Carrinho</S.ClearCartButton>
        </>
      )
      : (
        <CartEmpty isChatbotCatalog>
          Parece que seu carrinho ainda está vazio 😱 <br />
          <strong>Vamos mudar isso?</strong>
          <S.ButtonLink to={'/chatbot-catalog'}>
            <S.BackToHomeButton>Voltar para página inicial</S.BackToHomeButton>
          </S.ButtonLink>
        </CartEmpty>
      )}
    </S.CatalogCart>
  )
}

export default CatalogCart;